/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool usage user identity kind
 */
export const UserKind = {
  Email: "email",
  ExternalUserId: "external_user_id",
  UserId: "user_id",
  AgentId: "agent_id",
  Unknown: "unknown",
} as const;
/**
 * Tool usage user identity kind
 */
export type UserKind = ClosedEnum<typeof UserKind>;

/**
 * Tool usage user filter option with usage in the selected time window
 */
export type ToolUsageUserFilterOption = {
  /**
   * Number of tool usage events observed for the user identity
   */
  eventCount: number;
  /**
   * Stable user identity value used by filters
   */
  userKey: string;
  /**
   * Tool usage user identity kind
   */
  userKind: UserKind;
  /**
   * User-facing label for the user identity
   */
  userLabel: string;
};

/** @internal */
export const UserKind$inboundSchema: z.ZodMiniEnum<typeof UserKind> = z.enum(
  UserKind,
);

/** @internal */
export const ToolUsageUserFilterOption$inboundSchema: z.ZodMiniType<
  ToolUsageUserFilterOption,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    user_key: z.string(),
    user_kind: UserKind$inboundSchema,
    user_label: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "user_key": "userKey",
      "user_kind": "userKind",
      "user_label": "userLabel",
    });
  }),
);

export function toolUsageUserFilterOptionFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageUserFilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageUserFilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageUserFilterOption' from JSON`,
  );
}
